import { AxiosRequestConfig } from "axios";
import { apis } from "service";

const BASE_URL = "https://xxl6-bbr3-kxzs.m2.xano.io/api:";
const FOREX_ORDER_CANCEL = BASE_URL + "FiAQK2sE/close_order_forex_v3";
const PRODUCT_LIST = BASE_URL + 'FiAQK2sE/product_list_forex_v3'
export type CancelPayload = {
  reason: string;
  amount: number;
  order_id: number;
};
export type RateAndMargin = {
    l1_commission: number;
    l2_commission: number;
    l3_commission: number;
    l2_id: number;
    ibr_rate: number;
}
export type ProductDetail = {
    id: number;
    name: string;
    subCategory: string;
}
export type Product = {
    id: string;
    product_id: number;
    quantity: number;
    inr_amount: number;
    status: string;
    rate_and_margins: RateAndMargin[];
    product_detail: ProductDetail;
    country_currency_want: string;
    country_currency_have:string
}
export type ProductList = {
    id: number;
    product: Product[];
}
export const getProductList = async (order_id: number): Promise<ProductList> => {
    const payload: AxiosRequestConfig = {
        params: {
            order_id
        }
    }
    const response = await apis.get(PRODUCT_LIST, payload)
    return response.data
}
export const cancelForexOrder = async (data: CancelPayload): Promise<any> => {
  const payload: AxiosRequestConfig<CancelPayload> = {
    data: data,
  };
  return await apis.post(FOREX_ORDER_CANCEL, payload);
};
